import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetRolePermissions = {
  getRolePermissions: { data: null, loading: false, error: null },
};

export const getRolePermissions = createAsyncThunk('user/getRolePermissions', async (role, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/users/permissions`, {
      params: { role },
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetRolePermissions = {
  [getRolePermissions.pending]: (state) => {
    state.getRolePermissions.loading = true;
    state.getRolePermissions.error = null;
  },
  [getRolePermissions.fulfilled]: (state, action) => {
    state.getRolePermissions.loading = false;
    state.getRolePermissions.data = action.payload;
    state.getRolePermissions.error = null;
  },
  [getRolePermissions.rejected]: (state, action) => {
    state.getRolePermissions.loading = false;
    state.getRolePermissions.error = action.payload;
  },
};
